import { useRouter } from 'next/router';
import { useState } from 'react';
import { NextLink } from '~/i18n';
import { LinkAttributes } from '../_links';
import css from './styles.module.css';
import config from '~/translation.json';
import { useAuth } from '~/auth';
import { ActionPreventedAlert } from '~/components/common/alert/action-prevented';

const { languages } = config;

type HeaderLinkProps = LinkAttributes & { expanded?: boolean };

export const HeaderLink = ({
   href,
   text,
   icon,
   // children,
   // expanded,
   needsReview,
}: HeaderLinkProps) => {
   const { user } = useAuth();
   const router = useRouter();
   const regex = new RegExp(`^/(${Object.keys(languages).join('|')})`);
   const path = `${router.asPath.replace(regex, ``)}`;
   const active = path.startsWith(href);

   const [showPrevent, setShowPrevent] = useState(false);
   const underReview =
      user?.profile_strength &&
      (!user?.profile_strength?.has_business_profile || !user?.uploaded_legal_docs);
   const notReviewed = (needsReview && underReview) || false;

   const closePrevent = () => setShowPrevent(false);

   const handleUnderReviewClick = (e: any, prevent: boolean) => {
      if (prevent) {
         e.preventDefault();
         setShowPrevent(true);
      }
   };

   return (
      <div className="relative flex flex-col items-center justify-center w-full">
         <ActionPreventedAlert open={showPrevent} onClose={closePrevent} />
         <NextLink
            onClick={(e: any) => handleUnderReviewClick(e, notReviewed)}
            href={href}
            className={css.link}
            activeClassName={css.active}>
            <div>{icon}</div>
            <div className="text-xs text-center">{text}</div>
            {active ? (
               <div className="w-1 h-[48px] absolute ltr:left-0 rtl:right-0 top-1 mt-1.5 ltr:border-l-[4px] rtl:border-r-[4px] border-primary"></div>
            ) : null}
         </NextLink>
      </div>
   );
};
